import { render, staticRenderFns } from "./FlexMessage.vue?vue&type=template&id=3d213049&scoped=true&"
import script from "./FlexMessage.vue?vue&type=script&lang=js&"
export * from "./FlexMessage.vue?vue&type=script&lang=js&"
import style0 from "./FlexMessage.vue?vue&type=style&index=0&id=3d213049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d213049",
  null
  
)

export default component.exports